var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "container" }, [
    _c(
      "h1",
      {
        staticClass: "text-h4 text--text mb-6",
        attrs: { "data-qa": "column-content-h1" },
      },
      [_vm._v("\n    " + _vm._s(_vm.title) + "\n  ")]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "column-count-1 column-count-sm-2 column-count-md-3",
        attrs: { "data-qa": "column-content-list" },
      },
      [_vm._t("default")],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }